module.exports = __webpack_public_path__ + "img/leval-3.db7e8c66.png";